<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        薪酬福利
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 1. 发薪时间 -->
    <div class="labourParticulars" v-if="fingerprintShow1">
        <h4 class="labourParticulars-title titleClass-active">基本信息及提示</h4>
        <p>1. 发薪时间</p>
        <span class="spanClass active">签订全日制劳动合同、非全日制劳动合同的老师发薪时间为每月8日；签订劳务合同的老师发薪时间为每月10日。</span>
        <p>2. 计薪周期</p>
        <span class="spanClass active">坐班工资计薪日为每月26日至次月25日；课酬计薪日按自然月计算。</span>
        <p>3. 薪酬提示</p>
        <span class="spanClass active">如遇薪酬相关问题请联系张博雅（zhangboya3）、王海芳（wanghaifang）。</span>
        <p>4. 绩效提示</p>
        <span class="spanClass active">如遇绩效相关问题请联系赵阳（zhaoyang355）、李娇（lijiao15）。</span>
    </div>
    <!-- 绩效提示 -->
    <div class="labourParticulars" v-if="fingerprintShow2">
        <h4 class="labourParticulars-title titleClass-active">基本信息及提示</h4>
        <p>5. 课酬提示</p>
        <span class="spanClass active">如对课酬中课时部分有疑问，请联系部门教务老师核对上报课时数；如遇其他课酬相关问题请联系苑清娜（yuanqingna）、鸿迪孜（hongdizijianati）。</span>
        <p>6. 个人所得税提示</p>
        <span class="spanClass active">签订全日制劳动合同、非全日制劳动合同的老师缴纳工资税；签订劳务合同的老师缴纳劳务税。</span>
    </div>    
    <!-- 薪资查询 -->
    <!-- 1. EHR系统查询流程 -->
    <div class="labourParticulars" v-if="fingerprintShow3">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">薪资查询</h4>
        <p>1. EHR系统查询流程</p>
        <span class="spanClass active">每月10日起，登陆EHR系统（http://ehr.xdf.cn）查询工资明细。点击【自助服务】-【薪资和课酬】-【薪资单】。</span>
        <img src="../../assets/15.jpeg" alt="" class="classImage">
        <p>1. 云办公APP查询流程</p>
        <span class="spanClass active">登陆云办公APP，点击【HR自助】-【薪资单】（首次进入需绘制手势密码，请牢记密码）</span>
        <img src="../../assets/16.jpeg" alt="" class="classImage">
    </div>  
    <!-- 1. EHR系统查询流程 -->
    <div class="labourParticulars" v-if="fingerprintShow4">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">薪资查询</h4>
        <p>1. 云办公APP查询流程</p>
        <span class="spanClass active">登陆云办公APP，点击【HR自助】-【薪资单】（首次进入需绘制手势密码，请牢记密码）</span>
        <img src="../../assets/16.jpeg" alt="" class="classImage">
    </div>  
    <!-- 法定福利 -->
    <div class="labourParticulars" v-if="fingerprintShow5">
        <h4 class="labourParticulars-title titleClass-active">法定福利</h4>
        <p>1. 社会保险</p>
        <span class="spanClass active">学校为签订全日制劳动合同的员工缴纳社保，为签订非全日制劳动合同的员工缴纳雇主责任险。社保卡由老师们自由选择银行自行办理，下载“天津人力社保APP”可自助查询社保卡办理流程及社保卡相关信息。如遇社保相关问题请联系王君爽（wangjunshuang）。</span>
        <p>2. 住房公积金</p>
        <span class="spanClass active">学校为签订全日制劳动合同的员工缴纳住房公积金。公积金卡可到中国建设银行任意网点自行办理。如遇公积金相关问题请联系王君爽（wangjunshuang）。</span>
        <p>3. 法定节假日</p>
        <span class="spanClass active">详情请参见工时制度中关于休假制度的相关规定。</span>
    </div>  
    <!-- 节日福利 -->
    <div class="labourParticulars" v-if="fingerprintShow6">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">节日福利</h4>
        <span class="spanClass active">学校在传统年节及部分国际节日为员工准备了节日礼品、惊喜活动等。</span>
    </div> 
    <!-- 生日/结婚/生育福利 -->
    <div class="labourParticulars" v-if="fingerprintShow7">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">生日/结婚/生育福利</h4>
        <span class=" active" id="firstIdactive">1. 生日卡、结婚及生育礼金适用于签订全日制劳动合同的员工。</span>
        <span class=" active" id="firstIdactive">2. 在收到人力资源部生日卡领取提醒后，可前往人力资源部李娇（lijiao15）老师处领取。</span>
        <span class=" active" id="firstIdactive">3. 领取结婚礼金请携带结婚登记证书原件及复印件，前往人力资源部王学军（wangxuejun）老师处办理。</span>
        <span class=" active" id="firstIdactive">4. 领取生育礼金请携带员工子女出生证明原件及复印件，前往人力资源部王学军（wangxuejun）老师处办理。 </span>  
    </div> 
    <!-- 员工年度体检 -->
    <div class="labourParticulars" v-if="fingerprintShow8">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">员工福利</h4>
        <p>1. 员工年度体检</p>
        <span class="spanClass active">员工年度体检一般于每年4-5月开展，适用于签订全日制劳动合同的员工。</span>
        <p>2. 员工旅游</p>
        <span class="spanClass active">员工旅游一般于每年9-10月开展。境内外线路丰富，境外线路提供额外补助，可携带家属享受中标价格，适用于全体员工。
            员工旅游的假期标准，原则上为3天（不含休息日和法定假日），超出3天的应在参与人可享受的年休假中予以扣除，如无年休假的按照事假计算出勤。</span>  
    </div> 
    <!-- 员工报班优惠 -->
    <div class="labourParticulars" v-if="fingerprintShow9">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">员工福利</h4>
        <p>3. 员工报班优惠</p>
        <span class="spanClass active">参见员工报班优惠制度（附录二）。</span>
        <p>4. 员工推荐奖励</p>
        <span class="spanClass active">参见“伯乐奖”执行办法（附录三）。</span>  
        <p>5. 抚恤</p>
        <span class="spanClass active">员工因故去世，或员工的直系亲属（指二代以内直系亲属（包括法律拟制的直系亲属），包括父亲、母亲、丈夫、妻子、子女、养父母、养子女）因故去世，学校按照集团规定发放抚恤金。</span>  
    </div> 
    <div class="labourParticulars" v-if="fingerprintShow10">
        <h4 class="labourParticulars-title titleClass-active" id="active-box-border">企业文化微信号</h4>
        <span class="spanClass active">扫描下方二维码，添加“津津有味”好友，积分好礼拿不停！了解更多福利活动，get更多“新玩法”。</span> 
        <img src="../../assets/3.png" alt="" class="QRcode">
    </div>
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow1: false,
            fingerprintShow2: false,
            fingerprintShow3: false,
            fingerprintShow4: false,
            fingerprintShow5: false,
            fingerprintShow6: false,
            fingerprintShow7: false,
            fingerprintShow8: false,
            fingerprintShow9: false,
            fingerprintShow10: false,
            fingerprintShow11: false,
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'yu'){
                this.$router.push({name:"IssueManpower"})
            } else {
                this.$router.push({name:"WelfareRemuneration"})
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "666"
                }
            })
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 11) {
                this.fingerprintShow1 = true;
            } else if(code == 12){
                this.fingerprintShow2 = true
            } else if(code == 1){
                this.fingerprintShow3 = true
            } else if(code == 2){
                this.fingerprintShow4 = true
            } else if(code == 91) {
                this.fingerprintShow5 = true
            } else if(code == 92){
                this.fingerprintShow6 = true
            } else if(code == 93) {
                this.fingerprintShow7 = true
            } else if(code == 94) {
                this.fingerprintShow8 = true
            } else if(code == 96) {
                this.fingerprintShow9 = true
            } else if(code == 99) {
                this.fingerprintShow10 = true
            }
        }
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 25px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 50% !important;
    display: block;
    margin: 10px auto;
}

.titleClass-active {
  font-size: 16px
}

.active {
    line-height: 30px;
    letter-spacing:2px;
}

.classImage {
    width: 50%;
    display: block;
    margin: 30px auto;
}
#active-box-border {
    margin-bottom: 20px;
}
#firstIdactive {
    text-indent: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/WelfareRemuneration/welfareRemuneration1.vue